import { baseAssets } from './assets'
import { lightThemeColors } from './colors'
import { DEFAULT_THEME, Theme } from './theme'
import { defaultProductTypesToMetadata, PRODUCT_TYPE, ThemeMetadata } from '../productType'

export const getProductTypeMetadata = (
  theme: Theme.DARK | Theme.LIGHT = DEFAULT_THEME,
  productType: PRODUCT_TYPE = PRODUCT_TYPE.WFMH,
): ThemeMetadata => {
  const productTypeMetadata = defaultProductTypesToMetadata[productType]
  if (productTypeMetadata) {
    const themeMetadata = productTypeMetadata.theme[theme]
    if (themeMetadata) {
      return themeMetadata
    }
  }

  return { colorTokens: lightThemeColors, assets: baseAssets }
}
